var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.1215 11.224L20.5937 5.48389C21.1354 4.91567 21.1354 3.99438 20.5937 3.42616C20.052 2.85795 19.1737 2.85795 18.632 3.42616L11.383 11.03C10.8723 11.5657 10.8723 12.4343 11.383 12.97L18.632 20.5738C19.1737 21.1421 20.052 21.1421 20.5937 20.5738C21.1354 20.0056 21.1354 19.0843 20.5937 18.5161L15.1215 12.776C14.7129 12.3475 14.7129 11.6525 15.1215 11.224Z",
    fill: "#87FF0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1215 11.224L12.5937 5.48389C13.1354 4.91567 13.1354 3.99438 12.5937 3.42616C12.052 2.85795 11.1737 2.85795 10.632 3.42616L3.38305 11.03C2.87232 11.5657 2.87232 12.4343 3.38305 12.97L10.632 20.5738C11.1737 21.1421 12.052 21.1421 12.5937 20.5738C13.1354 20.0056 13.1354 19.0843 12.5937 18.5161L7.1215 12.776C6.71292 12.3475 6.71292 11.6525 7.1215 11.224Z",
    fill: "#87FF0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocBack);
export default __webpack_public_path__ + "static/media/ic_soc_back.767630820f162c6b7b0972914f69a5c3.svg";
export { ForwardRef as ReactComponent };